<div class="flex gap-4 mb-2">
  <div class="w-full">
    <div class="flex pt-5 gap-4">

      <div class="w-1/5">
        <div *ngIf="isNew()" class="flex gap-2 items-center mb-2">
          <div class="flex w-full search-wrapper">
            <mat-form-field appearance="fill" class="w-full no-margin">
              <mat-label>Search existing Center</mat-label>
              <input type="text" placeholder="Type at least 3 letters" matInput [formControl]="centerControl" [matAutocomplete]="auto" [value]="existingCenterSearch" />
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option" (click)="fillCenter(option)">{{ option.c_name }}</mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-spinner *ngIf="isLoading" [diameter]="30"></mat-spinner>
          </div>
          <button mat-flat-button color="primary" mat-button (click)="clearData()">Clear data</button>
        </div>
        <!-- KEY INFO -->
        <div class="flex flex-col">
          <mat-form-field appearance="fill">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="centerData.c_name" />
          </mat-form-field>
          <app-autocomplete-wrapper #child [options]="countries" [label]="'Country'" [selectionChangeCallback]="onSelectionChange.bind(this)"></app-autocomplete-wrapper>
          <div class="flex gap-4">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>City</mat-label>
              <input matInput [(ngModel)]="centerData.c_city" />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>State</mat-label>
              <input matInput [(ngModel)]="centerData.c_state" />
            </mat-form-field>
          </div>
          <div class="flex gap-4">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Address</mat-label>
              <input matInput [(ngModel)]="centerData.c_address" />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>Zip code</mat-label>
              <input matInput [(ngModel)]="centerData.c_zip" />
            </mat-form-field>
          </div>
          <mat-form-field appearance="fill">
            <mat-label>website</mat-label>
            <input matInput [(ngModel)]="centerData.website" />
          </mat-form-field>
          <div class="flex gap-4">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Center ID</mat-label>
              <input matInput [(ngModel)]="centerData.c_US_systemID" />
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Center ID 2</mat-label>
              <input matInput [(ngModel)]="centerData.c_country_systemID2" />
            </mat-form-field>
          </div>
          <div class="flex gap-4">
            <mat-form-field class="w-full">
              <mat-label>{{ getFieldDescription("c_project_account_region") }}</mat-label>
              <mat-select [(value)]="getProjectData().c_project_account_region">
                <mat-option *ngFor="let region of availableRegions" [value]="region.id">{{ region.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- IMPACT -->
      <div class="w-1/3 flex flex-col">
        <div class="flex mb-2 justify-between">
          <h3 class="mat-h3">Impact</h3>
          <app-score-view [title]="'Impact'" [score]="impactScore" [projectId]="centerParams.projectId" [area]="'centerImpact'" [position]="'static'"></app-score-view>
        </div>

        <div class="pt-11">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>{{ getFieldDescription("c_decile") }}</mat-label>
            <input matInput [(ngModel)]="getProjectData().c_decile" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>{{ getFieldDescription("c_beds") }}</mat-label>
            <input type="number" matInput [(ngModel)]="centerData.c_beds" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>{{ getFieldDescription("c_inpatient_days") }}</mat-label>
            <input type="number" matInput [(ngModel)]="centerData.c_inpatient_days" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Center number of publications</mat-label>
            <input type="number" matInput [(ngModel)]="articlesCount" disabled="true"/>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Center number of clinical trials</mat-label>
            <input type="number" matInput [(ngModel)]="CTCount" disabled="true"/>
          </mat-form-field>
        </div>
        <div>
          <div class="flex gap-4 justify-end">
            <mat-form-field appearance="fill" class="w-1/2">
              <mat-label>{{ getFieldDescription("c_proj_impact_tier") }}</mat-label>
              <mat-select [(value)]="getProjectData().c_proj_impact_tier">
                <mat-option *ngFor="let tier of getTiers('c_proj_impact_tier')" [value]="tier.name" >{{ tier.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- POTENTIAL & UTILISATION -->
      <div class="w-2/3 flex flex-col">
        <div class="flex gap-4">

          <!-- POTENTIAL -->
          <div class="w-1/2">
            <div class="flex mb-2 justify-between">
              <h3 class="mat-h3">Potential</h3>
              <app-score-view [title]="'Potential'" [score]="centerPotentialScore" [projectId]="centerParams.projectId" [area]="'centerPotential'" [position]="'static'"></app-score-view>
            </div>
          </div>

          <!-- UTILISATION -->
          <div class="w-1/2">
            <div class="flex mb-2 justify-between">
              <div class="flex flex-col">
                <h3 class="mat-h3">Utilisation</h3>
                <p class="text-blue">{{ formattedSale() }}</p>
              </div>
              <app-score-view [title]="'Utilisation'" [score]="centerUtilScore" [projectId]="centerParams.projectId" [area]="'centerUtil'" [position]="'static'"></app-score-view>
            </div>
          </div>

        </div>
        <div class="w-full flex gap-4">
          <div class="w-full blue-background px-2 mb-2">
            <h3 class="mat-h3">KAM Input</h3>
            <div class="flex gap-4">
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>{{ getFieldDescription("c_proj_patient_potential1") }}</mat-label>
                <input type="number" matInput [(ngModel)]="getProjectData().c_proj_patient_potential1" />
              </mat-form-field>

              <mat-form-field appearance="fill" class="w-full">
                <mat-label>{{ getFieldDescription("patient_utilisation1") }}</mat-label>
                <input type="number" matInput [(ngModel)]="getProjectData().patient_utilisation1" />
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="w-full flex gap-4">
          <div class="w-1/2">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>{{ getFieldDescription("c_proj_patient_potential2") }}</mat-label>
              <input type="number" matInput [(ngModel)]="getProjectData().c_proj_patient_potential2" />
            </mat-form-field>
          </div>
          <div class="w-1/2">
            <div class="flex gap-4 items-center">
              <mat-form-field appearance="fill">
                <mat-label>{{ getFieldDescription("sales_latest_period") }}</mat-label>
                <input type="number" matInput [(ngModel)]="getProjectData().sales_latest_period" disabled="true" />
              </mat-form-field>
              <div *ngIf="latestSale && prevSale && latestSale.sales_count > prevSale.sales_count" class="w-12 h-12 flex justify-center items-center">
                <mat-icon class="text-green-500">add</mat-icon>
              </div>
              <div *ngIf="latestSale && prevSale && latestSale.sales_count < prevSale.sales_count" class="w-12 h-12 flex justify-center items-center">
                <mat-icon class="text-red-600">remove</mat-icon>
              </div>
              <div *ngIf="latestSale && prevSale && latestSale.sales_count === prevSale.sales_count" class="w-12 h-12 flex justify-center items-center">
                <mat-icon>remove</mat-icon>
              </div>
              <div *ngIf="latestSale === undefined || prevSale === undefined" class="w-12 h-12 flex justify-center items-center">
                <mat-icon>remove</mat-icon>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full flex gap-4">
          <div class="w-1/2">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>{{ getFieldDescription("c_proj_patient_potential3") }}</mat-label>
              <input type="number" matInput [(ngModel)]="getProjectData().c_proj_patient_potential3" />
            </mat-form-field>
          </div>
          <div class="w-1/2">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>{{ getFieldDescription("sales_patient_equivalents") }}</mat-label>
              <input type="number" matInput [(ngModel)]="getProjectData().sales_patient_equivalents" disabled="true" />
            </mat-form-field>
          </div>
        </div>

        <div class="w-full flex gap-4">
          <div class="w-1/2">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>{{ getFieldDescription("c_proj_patient_potential4") }}</mat-label>
              <input type="number" matInput [(ngModel)]="getProjectData().c_proj_patient_potential4" />
            </mat-form-field>
          </div>
          <div class="w-1/2">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>{{ getFieldDescription("sales_momentum_short") }}</mat-label>
              <input matInput [(ngModel)]="sales_momentum_short" disabled="true" />
            </mat-form-field>
          </div>
        </div>

        <div class="w-full flex gap-4">
          <div class="w-1/2">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>{{ getFieldDescription("c_proj_patient_potential5") }}</mat-label>
              <input type="number" matInput [(ngModel)]="getProjectData().c_proj_patient_potential5" />
            </mat-form-field>
          </div>
          <div class="w-1/2">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>{{ getFieldDescription("sales_momentum_long") }}</mat-label>
              <input matInput [(ngModel)]="sales_momentum_long" disabled="true" />
            </mat-form-field>
          </div>
        </div>

        <div class="w-full flex gap-4">
          <div class="w-1/2">
            <div class="flex gap-4 justify-end">
              <mat-form-field appearance="fill" class="w-1/2">
                <mat-label>{{ getFieldDescription("c_proj_bu1_potential1") }}</mat-label>
                <mat-select [(value)]="getProjectData().c_proj_bu1_potential1">
                  <mat-option *ngFor="let tier of getTiers('c_proj_bu1_potential1')" [value]="tier.name">{{ tier.name }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="w-1/2">
            <div class="flex gap-4 justify-end">
              <mat-form-field appearance="fill" class="w-1/2">
                <mat-label>{{ getFieldDescription("c_proj_bu1_use1") }}</mat-label>
                <mat-select [(value)]="getProjectData().c_proj_bu1_use1">
                  <mat-option *ngFor="let tier of getTiers('c_proj_bu1_use1')" [value]="tier.name">{{ tier.name }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="w-1/5">
        <!-- LATEST NEWS -->
        <div class="blue-background w-full p-2 pb-4 overflow-auto max-h-[640px]">
          <h3 class="mat-h3">Latest relevant news</h3>
          <div *ngIf="newsUpdateInProgress" class="relative flex items-center justify-center mb-2">
            <p class="text-gray mr-2">Loading latest news...</p>
            <mat-spinner class="relative" [diameter]="20" color="accent"></mat-spinner>
          </div>
          <p class="text-xs text-slate-500 mb-2">{{ getCenterNews().updatedAt | date : "medium" }}</p>
          <app-markdown [input]="getCenterNews().news" [citations]="getCenterNews().citations"></app-markdown>
        </div>
      </div>


    </div>
  </div>
</div>

<div class="flex gap-4">
  <!-- IMPACT AND POTENTIAL & UTILISATION HERE -->
</div>

<!-- ACCOUNT PLAN -->
<div class="w-full blue-background p-2 mt-2">
  <h3 class="mat-h3">Account Planning</h3>
  <div class="grid grid-cols-12 gap-x-4 gap-y-px">
    <div class="col-span-6 flex items-center justify-center">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Account vision</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Account vision" [(ngModel)]="getProjectData().planning.center_vision"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-6 flex items-center justify-center">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Account Strategy</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Account Strategy" [(ngModel)]="getProjectData().planning.center_strategy"></textarea>
      </mat-form-field>
    </div>

    <h4 class="mat-h4 pt-2 col-span-1">Personal Resources</h4>
    <div class="col-span-5">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>What, who, how & how much?</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="What, who, how & how much?" [(ngModel)]="getProjectData().planning.personal_resources.info"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Contrib. to business ojective *1, 2, 3, 4</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Contributing to which business objective? *1,2,3,4" [(ngModel)]="getProjectData().planning.personal_resources.objective"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Resources needed (FTE, €, other)</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Resources needed (FTE, €, other)" [(ngModel)]="getProjectData().planning.personal_resources.resource_needed"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Time-tabled (Q, month, milestone…)</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Time-tabled (Q, month, milestone etc.)" [(ngModel)]="getProjectData().planning.personal_resources.time"></textarea>
      </mat-form-field>
    </div>

    <h4 class="mat-h4 pt-2 col-span-1">Other Resources</h4>
    <div class="col-span-5">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>What, who, how & how much?</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="What, who, how & how much?" [(ngModel)]="getProjectData().planning.other_resources.info"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Contributing to which business objective? *1,2,3,4</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Contributing to which business objective? *1,2,3,4" [(ngModel)]="getProjectData().planning.other_resources.objective"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Resources needed (FTE, €, other)</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Resources needed (FTE, €, other)" [(ngModel)]="getProjectData().planning.other_resources.resource_needed"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Time-tabled (Q, month, milestone etc.)</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Time-tabled (Q, month, milestone etc.)" [(ngModel)]="getProjectData().planning.other_resources.time"></textarea>
      </mat-form-field>
    </div>

    <h4 class="mat-h4 pt-2 col-span-1">Promotional</h4>
    <div class="col-span-5">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>What, who, how & how much?</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="What, who, how & how much?" [(ngModel)]="getProjectData().planning.promotional_resources.info"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Contributing to which business objective? *1,2,3,4</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Contributing to which business objective? *1,2,3,4" [(ngModel)]="getProjectData().planning.promotional_resources.objective"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Resources needed (FTE, €, other)</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Resources needed (FTE, €, other)" [(ngModel)]="getProjectData().planning.promotional_resources.resource_needed"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Time-tabled (Q, month, milestone etc.)</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Time-tabled (Q, month, milestone etc.)" [(ngModel)]="getProjectData().planning.promotional_resources.time"></textarea>
      </mat-form-field>
    </div>

    <h4 class="mat-h4 pt-2 col-span-1">Different / tailor made</h4>
    <div class="col-span-5">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>What, who, how & how much?</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="What, who, how & how much?" [(ngModel)]="getProjectData().planning.different_resources.info"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Contributing to which business objective? *1,2,3,4</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Contributing to which business objective? *1,2,3,4" [(ngModel)]="getProjectData().planning.different_resources.objective"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Resources needed (FTE, €, other)</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Resources needed (FTE, €, other)" [(ngModel)]="getProjectData().planning.different_resources.resource_needed"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-2">
      <mat-form-field appearance="fill" class="w-full !h-32">
        <mat-label>Time-tabled (Q, month, milestone etc.)</mat-label>
        <textarea class="!h-24" id="no-save-on-enter--1" matInput placeholder="Time-tabled (Q, month, milestone etc.)" [(ngModel)]="getProjectData().planning.different_resources.time"></textarea>
      </mat-form-field>
    </div>

    <p class="col-span-12 pt-2">*1. Account Revenue/ROI, 2. Developing/Improving Relationship/Partnership, 3. Contribute to Corporate Image, 4. Intangible Elements</p>
  </div>
</div>

<!-- BOTTOM PART -->
<div class="w-full gap-4 blue-background p-2 mt-4 clearfix">
  <!-- Treatment goals -->
  <div class="w-4/12 min-w-[300px] float-left mb-4">
    <h3 class="mat-h3">Treatment goals</h3>
    <div class="account-plan-area p-1">
      <p class="mb-4 text-gray">Treatment objectives prioritized by the physicians at this center</p>
      <div *ngFor="let tg of availableTreatmentGoals; index as itg" class="flex gap-4 items-center h-10 mt-1">
        <mat-checkbox *ngIf="this.getProjectData().treatment_goals_enabled" class="mt-2" [(ngModel)]="getProjectData().treatment_goals_enabled[itg]"></mat-checkbox>
        <p class="mt-2 text-gray">{{ tg }}</p>
      </div>
    </div>
  </div>
  <!-- Therapy - Treatment used -->
  <div class="w-2/12 min-w-[300px] float-left mb-4">
    <h3 class="mat-h3">Treatment used</h3>
    <div class="account-plan-area p-1">
      <p class="text-gray mb-4">Therapies used in Center</p>
      <table>
        <tr>
          <th class="th-left text-gray font-normal">#</th>
          <th class="th-left w-20 text-gray font-normal">validated</th>
          <th class="th-left text-gray font-normal">Therapy</th>
        </tr>
        <tr>
          <td>
            <input class="w-10 text-gray" type="number" matInput disabled="true" [(ngModel)]="getProjectData().treatment_option_total_count" />
          </td>
          <td></td>
          <td class="h-10 text-gray">Total</td>
        </tr>
        <tr *ngFor="let to of availableTreatmentOptions; index as ito">
          <td>
            <input *ngIf="this.getProjectData().treatment_options_counts" class="w-10" type="number" matInput (ngModelChange)="onTherapyChange($event, ito)" [(ngModel)]="getProjectData().treatment_options_counts[ito]" />
          </td>
          <td>
            <mat-checkbox *ngIf="this.getProjectData().treatment_options_validated" [(ngModel)]="getProjectData().treatment_options_validated[ito]"></mat-checkbox>
          </td>
          <td>
            <p class="text-gray">{{ to }}</p>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <!-- used in patients -->
  <div class="w-2/12 min-w-[300px] max-w-[385px] float-left mb-4">
    <h3 class="mat-h3">{{ project?.name || "" }} used in patients</h3>
    <div class="account-plan-area p-1">
      <p class="text-gray mb-4">Patient profiles treated</p>
      <div *ngFor="let tu of availableTreatmentUses; index as itu" class="flex gap-4 items-center h-10 mt-1">
        <mat-checkbox *ngIf="this.getProjectData().treatment_uses_enabled" class="mt-2" [(ngModel)]="getProjectData().treatment_uses_enabled[itu]">
        </mat-checkbox>
        <p class="mt-2 text-gray">{{ tu }}</p>
      </div>
    </div>
  </div>
  <!-- Decision makers -->
  <div class="w-4/12 min-w-[300px] max-w-[300px] float-left mb-4">
    <h3 class="mat-h3">Decision makers</h3>
    <div class="decision-makers p-1">
      <p class="text-gray">Who are the relevant decision makers and influencers?</p>
    </div>
    <mat-form-field appearance="fill" class="w-full !h-[360px]">
      <textarea id="no-save-on-enter--5" class="!h-[336px]" matInput placeholder="Center decision makers" [(ngModel)]="getProjectData().center_decision_makers"></textarea>
    </mat-form-field>
  </div>
</div>

<!-- TABLES -->
<app-hcps-table [centerParams]="centerParams" [centerData]="centerData"></app-hcps-table>
<app-sales-table [centerParams]="centerParams" [centerData]="centerData"></app-sales-table>
